<!--
  app/components/pages/how-to-play/HtpSectionSecretCards.vue
-->
<script setup lang="ts">
import { useNuxtApp } from "#imports";
import ContextLogoCrown from "~/components/context-shared/ContextLogoCrown.vue";

const { $t } = useNuxtApp();

const secretCards = [
  { key: "goalX2", img: "/img/htp/cards/goal-x2.png" },
  { key: "suspension", img: "/img/htp/cards/suspension.png" },
  { key: "starPlayer", img: "/img/htp/cards/star-player.png" },
  { key: "shootout", img: "/img/htp/cards/shootout.png" },
  { key: "joker", img: "/img/htp/cards/joker.png" },
  { key: "reversePenalty", img: "/img/htp/cards/reverse-penalty.png" },
  { key: "penalty", img: "/img/htp/cards/penalty.png" },
];
</script>

<template>
  <div class="space-y-10 bigsm:space-y-16">
    <!-- Secret Cards -->
    <section id="secret-cards" class="scroll-mt-48">
      <div
        class="flex flex-col bigsm:flex-row bigsm:items-baseline gap-1 bigsm:gap-4 mb-6 pb-2 bigsm:border-b bigsm:border-gray-700"
      >
        <div
          class="flex items-baseline gap-3 shrink-0 border-b border-gray-700 pb-2 bigsm:pb-0 bigsm:border-none"
        >
          <span class="text-primary shrink-0 self-center"><ContextLogoCrown :width="28" :height="28" /></span>
          <h2 class="font-kings text-3xl bigsm:text-4xl uppercase">
            {{ $t("howToPlay.section.secretCards.title") }}
          </h2>
        </div>
        <p class="text-gray-400 text-sm pl-6 bigsm:pl-0 pt-2 bigsm:pt-0">
          {{ $t("howToPlay.section.secretCards.intro") }}
        </p>
      </div>

      <ul
        class="grid grid-cols-1 sm:grid-cols-2 bigsm:grid-cols-3 gap-x-4 gap-y-4 bigsm:gap-x-8 bigsm:gap-y-6 px-4 bigsm:px-6"
      >
        <li
          v-for="(card, i) in secretCards"
          :key="card ? card.key : `empty-${i}`"
          class="flex gap-4 sm:flex-col sm:gap-0 bigsm:gap-4 bigsm:flex-row bigsm:items-start"
        >
          <template v-if="card">
            <NuxtImg
              :src="card.img"
              :alt="$t(`howToPlay.section.secretCards.${card.key}`) as string"
              width="128"
              height="184"
              format="webp"
              loading="lazy"
              class="block h-auto w-16 object-contain bigsm:w-20 mb-2 bigsm:mb-0 bigsm:mx-0 transition-all duration-200 ease-out hover:-translate-y-2 hover:scale-[1.08] hover:drop-shadow-[0_8px_20px_rgba(60,170,54,0.45)]"
            />
            <div class="min-w-0">
              <span
                class="font-kings text-lg bigsm:text-2xl uppercase italic block mb-1 leading-none"
                style="color: #3caa36"
              >
                {{ $t(`howToPlay.section.secretCards.${card.key}`) }}
              </span>
              <p class="text-gray-300 text-sm bigsm:text-base">
                {{ $t(`howToPlay.section.secretCards.${card.key}.description`) }}
              </p>
            </div>
          </template>
        </li>
      </ul>
    </section>

    <!-- President Penalty -->
    <section>
      <h3 class="text-primary text-lg md:text-xl font-semibold mb-4 md:mb-6">
        {{ $t("howToPlay.section.presidentPenalty.title") }}
      </h3>

      <div class="flex flex-col md:flex-row gap-4 md:gap-12 items-start px-4 md:px-6">
        <ul class="flex-1 space-y-2 md:space-y-3">
          <li v-for="n in 4" :key="n" class="flex gap-2 items-start">
            <span class="text-primary shrink-0 font-kings">—</span>
            <span class="text-gray-300 leading-relaxed">
              {{ $t(`howToPlay.section.presidentPenalty.rule${n}`) }}
            </span>
          </li>
        </ul>

        <div class="w-full max-w-full md:max-w-[40%] px-8 md:px-12 shrink-0 mx-auto">
          <NuxtImg
            src="/img/htp/penalty-president.jpg"
            width="320"
            height="228"
            format="webp"
            loading="lazy"
            :alt="$t('howToPlay.section.presidentPenalty.title') as string"
            class="w-full h-auto block rounded-lg rounded-tl-[75px] rounded-br-[75px]"
          />
        </div>
      </div>
    </section>
  </div>
</template>
